import { useState } from 'react';

const STORAGE_KEY = 'captions_favorites';

const load = () => {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) ?? [];
    } catch {
        return [];
    }
};

const useFavorites = () => {
    const [favorites, setFavorites] = useState(load);

    const persist = (next) => {
        setFavorites(next);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    };

    const isFavorited = (quote) => favorites.some((f) => f.text === quote.text);

    const toggleFavorite = (quote) => {
        if (isFavorited(quote)) {
            persist(favorites.filter((f) => f.text !== quote.text));
        } else {
            persist([{ ...quote, savedAt: Date.now() }, ...favorites]);
        }
    };

    return { favorites, isFavorited, toggleFavorite };
};

export default useFavorites;
